import { PiUserCircleFill } from 'react-icons/pi';
import { FaBell, FaPhoneAlt } from 'react-icons/fa';
import { FaBarsStaggered } from 'react-icons/fa6';
import { useState, useRef, useEffect } from 'react';
import { PiUserRectangle } from 'react-icons/pi';
import { ImExit } from 'react-icons/im';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { logout } from '../utils/logout';
import { MdEmail, MdPayments } from 'react-icons/md';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { MdHistory } from 'react-icons/md';
import { Tooltip } from '@mui/material';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import LoginIcon from '@mui/icons-material/Login';
import LockResetIcon from '@mui/icons-material/LockReset';

const Header = ({ setIsSidebarOpen, className = '' }) => {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [actionsOpen, setActionsOpen] = useState(false);
  const menuRef = useRef(null);
  const actionRef = useRef(null);
  const { userDetails, userPermissions } = useSelector(
    (state) => state.auth?.successData,
  );
  useEffect(() => {
    function handleClickOutside(event) {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    }
    if (menuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [menuOpen]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (actionRef.current && !actionRef.current.contains(event.target)) {
        setActionsOpen(false);
      }
    }
    if (actionsOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [actionsOpen]);

  return (
    <header className={`bg-[#EAEEFD] z-10 ${className} `}>
      <div className='flex items-center justify-between px-1 py-2'>
        <button
          className='p-2 bg-white rounded-sm shadow-sm hover:bg-gray-100 sm:hidden'
          onClick={() => setIsSidebarOpen((prev) => !prev)}
        >
          <FaBarsStaggered size={24} className='text-blue-600' />
        </button>{' '}
        <div className='flex items-center gap-2 ml-auto '>
          {/* Customer Support */}
          <div
            className='flex gap-x-4 justify-end mr-6 flex-wrap
           gap-y-0 max-[700px]:hidden  text-blue-600 '
          >
            <div className='flex items-center gap-1 text-lg font-semibold '>
              <span className='mr-4 font-bold '>{`Customer Care : `}</span>
              <span className='flex items-center gap-2 animate-pulse '>
                <FaPhoneAlt className='text-lg ' /> 7075589531
              </span>
            </div>

            <div className='flex items-center gap-1 ml-auto text-lg font-semibold '>
              <span className='flex items-center gap-2 animate-pulse'>
                <MdEmail className='text-lg ' />
                <span>customercare@staticval.com</span>
              </span>
            </div>
          </div>

          {/* Notifications Button */}
          <Tooltip title='Notifications'>
            <button
              className='relative p-2 transition duration-300 bg-white rounded-full shadow hover:bg-gray-100'
              onClick={() => {
                navigate('/settings', {
                  state: {
                    defaultValue:
                      userDetails?.role?.toLowerCase() === 'admin' ? 4 : 0,
                  },
                });
              }}
            >
              <span className='absolute flex top-1 right-1 size-2'>
                <span className='absolute inline-flex rounded-full opacity-75 animate-ping size-full'></span>
                <span className='relative inline-flex rounded-full size-2'></span>
              </span>
              <FaBell />
              <span className='absolute top-0 right-0'>
                <span className='relative flex size-2'>
                  <span className='absolute inline-flex bg-red-200 rounded-full opacity-75 size-full animate-ping'></span>
                  <span className='relative inline-flex bg-red-500 rounded-full size-2'></span>
                </span>
              </span>
            </button>
          </Tooltip>
          {/* Actions Menu */}
          <Tooltip title='Quick Access'>
            <div className='relative ' ref={actionRef}>
              <div
                onClick={() => {
                  setActionsOpen((prev) => !prev);
                  setMenuOpen(false);
                }}
                className='grid shrink-0 w-9 place-content-center gap-[2px] grid-cols-3 *:size-[4.5px] *:bg-black *:rounded-full shadow-lg rounded-full p-[8.5px] bg-white hover:bg-gray-100 transition duration-300'
              >
                <div></div>
                <div></div>
                <div></div> <div></div>
                <div></div>
                <div></div> <div></div>
                <div></div>
                <div></div>
              </div>
              <div
                onClick={() => setActionsOpen(false)}
                className={` top-full  left-1/2 -translate-x-1/2   transition-all duration-500 absolute  mt-2 bg-white rounded-2xl shadow z-20 py-2
                  ${actionsOpen ? 'opacity-100 scale-100 pointer-events-auto' : 'opacity-0 scale-95 pointer-events-none'} 
                  grid gap-2 grid-cols-2 w-max  p-3 border-2`}
              >
                {' '}
                <div className='col-span-2 my-2'></div>
                {/* payments */}
                {userPermissions?.payments && (
                  <div
                    className='flex flex-col items-center cursor-pointer'
                    onClick={() => {
                      navigate('/payments');
                    }}
                  >
                    {' '}
                    <MdPayments className='text-green-600 size-6' /> Payments
                  </div>
                )}
                {/* StudentInfo */}
                {userPermissions?.studentManagement && (
                  <div
                    className='flex flex-col items-center cursor-pointer'
                    onClick={() => navigate('/students/studentDetails')}
                  >
                    <AccountCircleIcon className='text-blue-600 size-6' />
                    Student Info
                  </div>
                )}
                {/* Add Student */}
                {userPermissions?.studentManagement && (
                  <div
                    className='flex flex-col items-center cursor-pointer'
                    onClick={() =>
                      navigate('/students', {
                        state: {
                          openStudentAdd: true,
                        },
                      })
                    }
                  >
                    <PersonAddIcon className='text-blue-600 size-6' />
                    Add Student
                  </div>
                )}
                {/* History */}
                {userPermissions?.history && (
                  <div
                    className='flex flex-col items-center cursor-pointer'
                    onClick={() =>
                      navigate('/history', { state: { defaultValue: 0 } })
                    }
                  >
                    <MdHistory className='text-red-600 size-6' />
                    History
                  </div>
                )}
                {/* New Login */}
                {userDetails?.role?.toLowerCase() === 'admin' && (
                  <div
                    className='flex flex-col items-center cursor-pointer'
                    onClick={() =>
                      navigate('/settings', { state: { defaultValue: 2 } })
                    }
                  >
                    <LoginIcon className='text-red-600 size-6' />
                    NewLogin
                  </div>
                )}
                {/* Change Password */}
                <div
                  className='flex flex-col items-center cursor-pointer'
                  onClick={() =>
                    navigate('/settings', {
                      state: {
                        defaultValue:
                          userDetails?.role?.toLowerCase() === 'admin' ? 5 : 1,
                      },
                    })
                  }
                >
                  <LockResetIcon className='text-blue-600 size-6' />
                  change Password
                </div>
                <div className='col-span-2 my-2'></div>
              </div>
            </div>
          </Tooltip>
          {/* Profile Menu */}
          <div className='relative ' ref={menuRef}>
            <button
              className='flex items-center px-3 py-1 transition duration-300 bg-white shadow rounded-xl focus:outline-none hover:bg-gray-100'
              onClick={() => {
                setMenuOpen((open) => !open);
                setActionsOpen(false);
              }}
            >
              <div className='flex items-center justify-center mr-2 bg-transparent rounded size-8'>
                <PiUserCircleFill size={28} className='text-blue-600' />
              </div>
              <div>
                <div className='text-sm font-semibold leading-none text-left'>
                  {userDetails?.userName}
                </div>
                <div className='text-xs text-gray-500'>
                  {userDetails?.designation}
                </div>
              </div>
            </button>

            <div
              className={`transition-all duration-500 absolute right-0 mt-2 w-40 bg-white rounded-2xl shadow-lg z-20 py-2 ${menuOpen ? 'opacity-100 scale-100 pointer-events-auto' : 'opacity-0 scale-95 pointer-events-none'}`}
            >
              <button
                onClick={() => {
                  navigate('/settings', {
                    state: {
                      defaultValue:
                        userDetails?.role?.toLowerCase() === 'admin' ? 6 : 2,
                    },
                  });
                  setMenuOpen((open) => !open);
                }}
                className='flex items-center w-full gap-2 px-4 py-2 text-sm text-left hover:bg-gray-100'
              >
                <PiUserRectangle size={20} className='text-blue-600' />{' '}
                MyProfile
              </button>
              <button
                onClick={async () => {
                  localStorage.setItem('userName', null);
                  await logout();
                  setMenuOpen((open) => !open);
                }}
                className='flex items-center w-full gap-2 px-4 py-2 text-sm text-left text-red-600 hover:bg-gray-100'
              >
                <ImExit size={20} className='text-red-600' /> Logout
              </button>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
